import { Component, ViewEncapsulation, inject } from "@angular/core";
import { MAT_SNACK_BAR_DATA } from "@angular/material/snack-bar";

@Component({
    selector: "app-snack-bar",
    templateUrl: "./custome-snack-bar.component.html",
    styleUrls: ["./custome-snack-bar.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class CustomeSnackBarComponent {

  data = inject(MAT_SNACK_BAR_DATA);

  snackBarTypes = SnackBarTypes;

}

export enum SnackBarTypes {
  success = 0,
  error,
  warning,
}
